<template>
  <div class="copy-link text-center">
    <slot />
    <div class="copy-link__wrap">
      <VTextField
        ref="linkInput"
        id="linkInput"
        v-show="!hideLink"
        :value="link"
        denserequired
        outlined
        readonly
        :hide-details="true"
        class="body-2 mt-2 mb-1"
      />
      <VBtn
        v-if="!linkCopied"
        color="transparent"
        class="elevation-0 primary--text font-weight-regular"
        @click="copyLink"
      >
        {{ $t('copyLink') }}
      </VBtn>
      <div v-else class="d-flex align-center body-2 text-center button-height">
        <VIcon color="success" class="mr-2">
          mdi-check
        </VIcon>
        {{ $t('copied') }}
      </div>
    </div>
  </div>
</template>

<script>
import copy from 'clipboard-copy';

export default {
  name: 'CandidateInterviewCopyLink',
  props: {
    link: {
      type: String,
      required: true,
    },
    hideLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      linkCopied: false,
    };
  },
  mounted() {
    this.$refs.linkInput.$refs.input.select();
  },
  methods: {
    copyLink() {
      copy(this.link);
      this.linkCopied = true;
    },
  },
};
</script>

<style scoped lang="scss">
.copy-link {
  width: 100%;
  &__wrap {
    width: 100%;
    max-width: 19.625rem;
    margin: 0 auto;
  }
}

</style>

<i18n locale="en" lang="yaml">
copyLink: Copy link
copied: Link was copied
</i18n>

<i18n locale="ru" lang="yaml">
copyLink: Копировать ссылку
copied: Ссылка скопирована
</i18n>
